(function () {
  var originalSlides = null;
  var FALLBACK_LIMIT = 4; // quando a cor escolhida não tem fotos, mostra no máximo 4 fotos do produto

  function getColor() {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    const variantData = window.__variantData || [];
    const colorIndex = window.__colorOptionIndex ?? 0;

    if (!variantId) return null;

    const variant = variantData.find(function (v) {
      return String(v.id) === String(variantId);
    });

    return variant ? (variant.options[colorIndex] || '').toLowerCase().trim() : null;
  }

  function altOf(el) {
    const img = el.querySelector('img');
    return (img ? img.getAttribute('alt') || '' : '').toLowerCase().trim();
  }

  /* Computador (grade de 2 colunas): sempre mostra quantidade PAR de fotos.
     Se a quantidade visível for ímpar (e maior que 1), a última foto é ocultada para não sobrar uma sozinha na linha. */
  function evenDesktop() {
    const items = Array.from(document.querySelectorAll('.sf-product-media__desktop .sf-prod-media-item'));
    if (!items.length) return;
    items.forEach(function (item) {
      if (item.dataset.srfEvenHidden) { item.style.display = ''; delete item.dataset.srfEvenHidden; }
    });
    const visible = items.filter(function (item) { return item.style.display !== 'none' && window.getComputedStyle(item).display !== 'none'; });
    if (visible.length > 1 && visible.length % 2 === 1) {
      const last = visible[visible.length - 1];
      last.style.display = 'none';
      last.dataset.srfEvenHidden = '1';
    }
  }

  function filterMedia() {
    const color = getColor();
    if (!color) { evenDesktop(); return; }

    // Desktop: mostra as fotos da cor; se a cor não tiver foto, mostra as 4 primeiras fotos do produto
    const desktopItems = Array.from(document.querySelectorAll('.sf-product-media__desktop .sf-prod-media-item'));
    desktopItems.forEach(function (item) { if (item.dataset.srfEvenHidden) delete item.dataset.srfEvenHidden; });
    const desktopHasColor = desktopItems.some(function (item) { return altOf(item) === color; });
    desktopItems.forEach(function (item, i) {
      const alt = altOf(item);
      const show = desktopHasColor ? (alt === color || alt === '') : (i < FALLBACK_LIMIT);
      item.style.display = show ? '' : 'none';
    });
    evenDesktop();

    // Mobile (Splide)
    const splideEl = document.querySelector('.serafine-product-media__mobile .splide');
    if (!splideEl) return;

    const track = splideEl.querySelector('.splide__list');
    if (!track) return;

    if (!originalSlides) {
      originalSlides = Array.from(track.querySelectorAll('.splide__slide:not(.splide__slide--clone)'))
        .map(function (el) { return el.cloneNode(true); });
    }
    if (!originalSlides.length) return;

    const mobileHasColor = originalSlides.some(function (slide) { return altOf(slide) === color; });

    splideEl.classList.remove('is-initialized', 'is-active');
    splideEl.querySelectorAll('.splide__arrows').forEach(function (el) { el.remove(); });
    splideEl.querySelectorAll('.splide__pagination').forEach(function (el) { el.remove(); });
    track.innerHTML = '';
    originalSlides.forEach(function (slide, i) {
      const alt = altOf(slide);
      const show = mobileHasColor ? (alt === color || alt === '') : (i < FALLBACK_LIMIT);
      if (show) track.appendChild(slide.cloneNode(true));
    });

    new Splide(splideEl, { arrows: false, pagination: true }).mount();
  }

  const originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(history, arguments);
    setTimeout(filterMedia, 300);
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function () {
    originalReplaceState.apply(history, arguments);
    setTimeout(filterMedia, 300);
  };

  window.addEventListener('popstate', function () {
    setTimeout(filterMedia, 300);
  });

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(filterMedia, 500);
  });
  window.addEventListener('load', function () {
    setTimeout(evenDesktop, 800);
  });
})();
